import { call, put, takeLatest } from 'redux-saga/effects';

import { getMessageCounter } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData() {
  const response = yield call(getMessageCounter);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* messageCounterSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
